import axios, { AxiosError, HttpStatusCode } from 'axios';
import {
  FighterImageNotFoundError,
  FighterImageServerError,
} from '../../corelogic/domain/errors/fighterImage.error';
import { FIGHTER_IMAGE_ERROR_MESSAGES } from '../../corelogic/domain/errors/gateway.errorMessages/fighterImage.error.messages';
import { FighterImageGateway } from '../../corelogic/domain/ports/fighterImage.ports';
import { buildFighterImagePath } from '../../corelogic/domain/utils/fighterImage.utils';

export class S3FighterImageGateway implements FighterImageGateway {
  private mediaEndpoint: string;

  private handleFighterError(error: AxiosError): never {
    if (axios.isAxiosError(error)) {
      switch (error.response?.status) {
        case HttpStatusCode.NotFound:
          throw new FighterImageNotFoundError(
            FIGHTER_IMAGE_ERROR_MESSAGES.NOT_FOUND,
          );
        default:
          throw new FighterImageServerError(
            FIGHTER_IMAGE_ERROR_MESSAGES.SERVER_ERROR,
          );
      }
    }
    throw new FighterImageServerError(
      FIGHTER_IMAGE_ERROR_MESSAGES.SERVER_ERROR,
    );
  }

  constructor(mediaEndpoint: string) {
    this.mediaEndpoint = mediaEndpoint;
  }

  async getFighterImage(
    dob: Date,
    firstname?: string,
    lastname?: string,
  ): Promise<string> {
    const imagePath = buildFighterImagePath(firstname, lastname, dob);

    if (!imagePath) {
      throw new Error(
        'Unable to build fighter image path: missing required data',
      );
    }

    const url = `${this.mediaEndpoint}/${imagePath}`;

    try {
      const response: { data: Blob } = await axios.get(url, {
        headers: {
          Accept: 'image/png',
        },
        responseType: 'blob',
      });

      return window.URL.createObjectURL(response.data);
    } catch (error) {
      throw this.handleFighterError(error as AxiosError);
    }
  }
}
